module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0094.jpg?v=43968bf7";